<template>
  <div class="bmdiv">
    <mobile-top :pro-name="pro_name" :logo='logo'></mobile-top>
    <vue-signature
      v-bind:is-show-sign.sync="isShowSign"
      @set-sign="setElectronicSignatureFile"
    ></vue-signature>
    <form class="dinline-block bgw prelative vcenter" method="post">
      <div class="tcenter fs18 tc6 pt30 pb30 stt">
        正在报名（{{ pro_name }}）请填写报名信息
      </div>
      <!-- <a href="javascript:void(0);" class="close pabsolute br50 hbig twhite" @click="hiddenSign">X</a> -->
      <div class="mdiv">
        <input type="hidden" name="project_id" />
        <input
          type="text"
          class="form-control dblock wd100 mb20 trans"
          id="name"
          name="name"
          placeholder="请输入您的姓名"
          v-model="signName"
        />
        <input
          type="text"
          class="form-control dblock wd100 mb20 trans"
          id="mobile"
          name="mobile"
          placeholder="请输入手机号码"
          v-model="signPhone"
        />
        <input
          type="text"
          class="form-control dblock wd100 mb20 trans"
          id="cid"
          name="cid"
          placeholder="请输入身份证号"
          v-model="cid"
        />
         <input
          type="text"
          class="form-control dblock wd100 mb20 trans"
          id="company"
          name="company"
          placeholder="请输入单位"
          v-model="company"
        />
        <!-- <select v-show="!is_tk"
                class="form-control dblock wd100 mb20 trans"
                id="native_province"
                name="native_province"
                v-model="native_province"
                @change="getCityRegion"
        >
          <option value=0>请选择籍贯省</option>
          <option v-for="(item, index) in e_list.native_province_data" :value="index">
            {{ item }}
          </option>
        </select>
        <select v-show="!is_tk"
                class="form-control dblock wd100 mb20 trans"
                id="native_city"
                name="native_city"
                v-model="native_city"
                @change="getCountyRegion"
        >
          <option value="0">请选择籍贯市</option>
          <option v-for="(item, index) in r_list" :value="index">
            {{ item }}
          </option>
        </select>
        <select v-show="!is_tk"
                class="form-control dblock wd100 mb20 trans"
                id="native_county"
                name="native_county"
                v-model="native_county"
        >
          <option value="0">请选择籍贯区县</option>
          <option v-for="(item, index) in c_list" :value="index">
            {{ item }}
          </option>
        </select>
        <select v-show="!is_tk"
          class="form-control dblock wd100 mb20 trans"
          id="political_outlook"
          name="political_outlook"
          v-model="political_outlook"
        >
          <option value="0">请选择政治面貌</option>
          <option v-for="(item, index) in e_list.politic_status" :value="index">
            {{ item }}
          </option>
        </select>
        <select v-show="!is_tk"
          class="form-control dblock wd100 mb20 trans"
          id="edu_level"
          name="edu_level"
          v-model="edu_level"
        >
          <option value="">请选择文化程度</option>
          <option v-for="(item, index) in e_list.edu_level" :value="index">
            {{ item }}
          </option>
        </select> -->

				 <!-- <input v-if='this.domain == "tzvcst.cjnep.net"'
          type="text"
          class="form-control dblock wd100 mb20 trans"
					id="remark"
          name="remark"
          placeholder="请输入备注"
          v-model="remark"

        /> -->
        <!-- <input v-show="!is_tk"
          type="text"
          class="form-control dblock wd100 mb20 trans"
          id="remark"
          name="remark"
          placeholder="请输入志愿专业"
          v-model="remark"
        /> -->
        <div class="tleft fs0">
          <input
            type="text"
            class="tcode form-control dinline-block fs14 vtop"
            id="veri_code"
            name="veri_code"
            placeholder="请输入验证码"
            v-model="signCode"
          />
          <img
            id="imgCode"
            class="code dinline-block vtop"
            title="看不清，换一张"
            height="35"
            :src="imgSrc"
            @click="initImg"
          />
        </div>
        <!-- <div v-show="!is_tk" class="tleft fs0 signature" @click="isShowSign = true">
          <span>电子签名:</span>
          <input
            type="checkbox"
            class="content-select"
            checked="checked"
            v-if="electronicSignatureFile"
          />
          <input type="checkbox" class="content-select" v-else />
        </div> -->
      </div>
      <a href="#"
         :class="{ 'disabled-link': isDisabled }" class="zbtn clearn wd100 mt20 mb40 fs18 zbtn-gblue2" @click.prevent="subSigUp"
        >{{ buttonText }}</a
      >
    </form>
    <mobile-bottom :site-name="site_name"></mobile-bottom>
  </div>
</template>

<script>
import MobileTop from "../top";
import MobileBottom from "../bottom";
import Upload from "../../../item/upload";
import vueSignature from "../../../item/vueSignatureMobile";
export default {
  name: "sign",

  components: {
    MobileTop,
    MobileBottom,
    Upload,
    vueSignature,
  },

  //  props: [
  //     'projectId',
  //     'classId',
  //     'projectName',
  //     'isSignUp'
  //   ],

  data() {
    return {
	  'logo': '',
      imgSrc: "",
      signName: "",
      signPhone: "",
      signCode: "",
      cid: "",
      company:'',
      edu_level: "",
      political_outlook: 0,
      native_province: 0,
      native_city: 0,
      native_county: 0,
      e_list: [],
      r_list: [],
      c_list: [],
      remark: "",
      isShowSign: false,
      electronicSignatureFile: "",
      projectId: 0,
      classId: 0,
      projectName: "",
      pro_name: "",
      site_name: '',
			domain: '',
      isDisabled: false,
      buttonText: '提交',
      is_tk: false //是否是台科
    };
  },
  created() {
	//document.title = ''
	  this.getLogo()
    //console.log( this.$route.query)
    let { id, project_id, project_name } = this.$route.query;
    this.classId = id;
    this.projectId = project_id;
    this.pro_name = project_name;
		this.domain = document.domain //tzvcst.cjnep.net
    if(this.domain == 'tzvcst.cjnep.net')
      this.is_tk = true
    //this.is_tk = true
		//this.domain = 'tzvcst.cjnep.net' //测试 后期要注释掉
  },
  mounted() {
    //console.log(this.projectName)
    this.initImg();
    this.getdata();
    //console.log(this.projectId, this.classId)
  },

  methods: {
	  getLogo(){
       this.$request.getSims('site/school-info', {}, response => {
        if (response.status == 200 && response.data.code == 200) {
          let data = response.data.data
		      this.logo = data.logo
          document.title = data.site_name
          this.site_name = data.site_name
        }
      }, error => {
        // document.title = 'zhang'
        // this.logo = 'https://fs.cjnep.net/resources/kaifa/sims/logo.png'
        console.log(error)
      })
    },
    setElectronicSignatureFile: function (e, f) {
      this.electronicSignatureFile = e;
    },
    getdata: function () {
      this.$request.get(
        "training-skill/social-training-enroll-data",
        {},
        (response) => {
          if (response.status == 200) {
            if (response.data.code == 200) {
              this.e_list = response.data.data;
            } else {
              alert(response.data.message);
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
    },
    getCityRegion:function (){
      this.$request.get(
        "training-skill/region-city-data",
        {native_province:this.native_province},
        (response) => {
          if (response.status == 200) {
            if (response.data.code == 200) {
              this.r_list = response.data.data.native_city_data;
              this.native_city=0;
              this.c_list = [];
              this.native_county=0;
            } else {
              alert(response.data.message);
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
    },
    getCountyRegion:function (){
      this.$request.get(
        "training-skill/region-county-data",
        {native_city:this.native_city},
        (response) => {
          if (response.status == 200) {
            if (response.data.code == 200) {
              this.c_list = response.data.data.native_county_data;
              this.native_county=0;
            } else {
              alert(response.data.message);
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
    },
    // showSign:function () {
    //   this.$emit('show-sign-up');
    // },
    hiddenSign: function () {
      this.$emit("update:is-sign-up", false);
      // this.$emit('hide-sign-up');
    },
    initImg: function () {
      this.imgSrc =
        this.$request.request_url +
        "training-skill/image-code?unique_code=" +
        this.$elId +
        "&random=" +
        Math.random();
    },
    subSigUp: function () {
      if (this.isDisabled) {
        event.preventDefault(); // 阻止默认行为
        return; // 直接返回
      }
      if (this.projectId > 0) {
        if (!this.signName) {
          alert("请填写姓名");
          return false;
        }
        // if(!this.is_tk){//屏蔽台科
        //   if (!this.electronicSignatureFile) {
        //     alert("未签名");
        //     return false;
        //   }
        // }
        var getParam = {};
        getParam["discipline_id"] = this.projectId;
        getParam["class_id"] = this.classId;
        getParam["phone"] = this.signPhone;
        getParam["name"] = this.signName;
        getParam["cid"] = this.cid;
        getParam["code"] = this.signCode;
        getParam["unique_code"] = this.$elId;
        getParam["edu_level"] = this.edu_level;
        getParam["political_outlook"] = this.political_outlook;
        getParam["native_province"] = this.native_province;
        getParam["native_city"] = this.native_city;
        getParam["native_county"] = this.native_county;
        getParam["remark"] = this.remark;
        getParam["company"] = this.company;
        let param = new FormData();
        if (this.electronicSignatureFile) {
          param.append(
            "electronic_signature",
            this.electronicSignatureFile,
            "signature.jpg"
          );
        }
        for (let key in getParam) {
          param.append(key, getParam[key]);
        }
        let config = {
          headers: { "Content-Type": "multipart/form-data" },
        };
        // this.$request.post('training-skill/social-training-enroll',getParam,response => {
        this.$request.postFile(
          "training-skill/social-training-enroll",
          param,
          config,
          (response) => {
            if (response.status == 200) {
              if (response.data.code == 200) {
                alert("报名成功");
                this.isDisabled = true;
                this.buttonText = '已提交';
                //this.$emit("update:is-sign-up", false);
              } else {
                alert(response.data.message);
              }
            }
          },
          (error) => {
            console.log(error);
          }
        );
      } else {
        alert("无项目信息");
      }
    },
  },
};
</script>

<style scoped>
.stt {
  padding: 20px 30px;
}
.bmdiv {
  z-index: 1000;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.bmdiv::after {
  content: "";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}
.bmdiv form {
  width: 100%;
}
.bmdiv input {
  height: 40px;
  border: 1px solid #d8d8d8;
}
.bmdiv input {
  padding: 0 20px 0 20px;
  outline: none;
}
.bmdiv input:focus {
  border-color: #147ad8;
  box-shadow: 0 0 5px #147ad8;
}
.bmdiv input.wd100 {
  width: 100%;
}

.bmdiv select {
  height: 40px;
  border: 1px solid #d8d8d8;
}
.bmdiv select {
  padding: 0 20px 0 20px;
  outline: none;
}
.bmdiv select:focus {
  border-color: #147ad8;
  box-shadow: 0 0 5px #147ad8;
}
.bmdiv select.wd100 {
  width: 100%;
}

.bmdiv .code {
  float: right;
  height: 40px;
  max-width: 150px;
}
.bmdiv .pass {
  background-position: -10px -208px;
}
.bmdiv .tcode {
  margin-right: 20px;
  width: 50%;
}
.bmdiv .zbtn {
  height: 45px;
  line-height: 45px;
  letter-spacing: 5px;
  outline: none;
}
.bmdiv .zbtn:hover {
  box-shadow: 0 0 5px #147ad8;
}
.bmdiv .close {
  right: -18px;
  top: -18px;
  width: 36px;
  height: 36px;
  line-height: 36px;
  background: #147ad8;
}
.item-class {
  margin-bottom: 25px;
  font-size: 22px;
  font-weight: bold;
}
.item-content {
  margin-bottom: 30px;
}
.item-content td {
  border: 1px solid #000000;
  padding: 10px 0 10px 0;
}
.item-content table {
  border-collapse: collapse;
  width: 100%;
  text-align: center;
}
.signature {
  position: relative;
}
.signature::before {
  content: "";
  display: block;
  z-index: 100;
  width: 100%;
  height: 100%;
  position: absolute;
}
.signature span {
  font-size: 16px;
  vertical-align: middle;
}
.signature input {
  vertical-align: middle;
  margin-left: 10px;
}

form {
  height: 90%;
}
.mdiv {
  margin: 0px auto;
  padding: 5px 30px;
  /* max-height: calc( 100% - 180px);
    overflow-y: auto; */
}
form .zbtn-gblue2 {
  display: block;
  margin: 20px auto 40px;
  width: 60%;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/train/project/signUp.vue